import React from 'react';
import './InsightsPage.css';
import { FiAward, FiTrendingUp, FiAlertCircle, FiStar, FiBarChart2 } from 'react-icons/fi';
import { useApi } from './useApi';
import { useQuery } from 'react-query';

const AllTimeInsights = () => {
  const { authenticatedFetch } = useApi();

  const fetchJson = async (url) => {
    const res = await authenticatedFetch(url);
    if (!res.ok) throw new Error('Fetch failed');
    return res.json();
  };

  const { data: averagePoints = [], isLoading: avgLoading } = useQuery(
    'avgPoints', 
    () => fetchJson('/insights/player/average_points')
  );

  const { data: accolades = [], isLoading: accLoading } = useQuery(
    'accolades', 
    async () => {
      const data = await fetchJson('/insights/player/accolades');
      return data.sort((a, b) => b.wins - a.wins);
    }
  );

  const { data: bestRounds = [], isLoading: bestLoading } = useQuery(
    'bestRounds', 
    () => fetchJson('/insights/player/best_rounds')
  );

  const { data: blobAverages = [], isLoading: blobLoading } = useQuery(
    'blobAverages', 
    () => fetchJson('/insights/player/blobs')
  );

  const RenderTable = ({ title, icon: Icon, data, columns, mapping, isLoading }) => (
    <div className="premium-card insights-leaderboard-card">
      <div className="section-header"><Icon className="section-header-icon" /> {title}</div>
      {isLoading ? (
        <div className="empty-state-container"><p>Loading...</p></div>
      ) : data.length > 0 ? (
        <div className="table-container">
          <table className="insights-table">
            <thead><tr>{columns.map(c => <th key={c}>{c}</th>)}</tr></thead>
            <tbody>{data.map((item, i) => <tr key={i}>{mapping(item)}</tr>)}</tbody>
          </table>
        </div>
      ) : (
        <div className="empty-state-container"><FiAlertCircle className="empty-state-icon" /><p>No data.</p></div>
      )}
    </div>
  );

  return (
    <div className="all-time-insights-container">
      <RenderTable
        title="Top 10 Best Rounds"
        icon={FiStar}
        data={bestRounds}
        isLoading={bestLoading}
        columns={['Player', 'Tournament', 'Points']}
        mapping={r => <><td key="name">{r.player_name}</td><td key="t">{r.tournament_name}</td><td key="pts">{r.stableford_total}</td></>}
      />
      <RenderTable
        title="Accolades"
        icon={FiAward}
        data={accolades}
        isLoading={accLoading}
        columns={['Player', 'Wins', 'Top 3s', 'Lasts']}
        mapping={p => <><td key="name">{p.player_name}</td><td key="w">{p.wins}</td><td key="t3">{p.top3}</td><td key="l">{p.last}</td></>}
      />
      <RenderTable
        title="Top 20 Best Average Point Scorers"
        icon={FiBarChart2}
        data={averagePoints.slice(0, 20)}
        isLoading={avgLoading}
        columns={['Player', 'Avg Pts', 'Rounds']}
        mapping={p => <><td key="name">{p.player_name}</td><td key="avg">{p.average_points}</td><td key="rnd">{p.rounds_played}</td></>}
      />
      <RenderTable
        title="Blob Averages"
        icon={FiTrendingUp}
        data={blobAverages}
        isLoading={blobLoading}
        columns={['Player', 'Avg Blobs', 'Rounds']}
        mapping={p => <><td key="name">{p.player_name}</td><td key="avg">{p.average_blobs}</td><td key="rnd">{p.rounds_played}</td></>}
      />
    </div>
  );
};

export default AllTimeInsights;